import ConstraintResource from "../ConstraintResource.js";
import {Permission, Role} from "../Permissions.js";
import {useResourceStore} from "../../stores/resourceStore.js";

export default class UserResource extends ConstraintResource {
    /**
     * @param {string|Role} role
     * @param {any} options
     * @returns {boolean}
     */
    hasRole(role, options) {
        if(! role instanceof Role && typeof role !== 'string') {
            console.error('Invalid argument as role', role);
            return false;
        }

        return this.resolve(role, this.relations.roles, options);
    }

    /**
     * @param {string|Permission} permission
     * @param {any} options
     * @returns {boolean}
     */
    hasPermission(permission, options) {
        if(! permission instanceof Permission && typeof permission !== 'string') {
            console.error('Invalid argument as permission', permission);
            return false;
        }

        return this.resolve(permission, this.relations.permissions, options);
    }

    resolve(source, category, options) {
        if(!category) {
            console.error('Cannot resolve user ability without "category"! Was it loaded properly?');
            return false;
        }

        switch(typeof source) {
            case 'string':
                return this.resolveGluedString(source, category, options);
            case 'function':
                return this.resolveCallback(source, options);
            default: // object
                if(source instanceof Role || source instanceof Permission) {
                    return this.resolve(source.toString(), category, options);
                }

                let resolved = false;

                Object.keys(source).forEach((key) => { // Array
                    if(resolved) {
                        return;
                    }

                    let value = source[key];

                    resolved = this.resolve(value, category, options);
                });

                return resolved;

        }
    }

    resolveCallback(source, options) {
        return source(this.exposed, options);
    }

    resolveGluedString(source, category, options) {
        if (options?.hasOwnProperty('route')) {
            if (options.route.hasOwnProperty('to')) {
                for (let key in options.route.to.params) {
                    source = source.replace(`{${key}}`, options.route.to.params[key]);
                }
            }
        }

        return category?.includes(source) ?? false;

    }

    isLoggedIn() {
        const resourceStore = useResourceStore();

        if((resourceStore.getCurrentUser()?.data.uuid ?? false) === this.data.uuid) {
            return true;
        }

        return false; // TODO: check through of the server
    }
}

UserResource.prototype.casts = {
    created_at: Date,
    updated_at: Date,
    deleted_at: Date,
    valid_from: Date,
    valid_until: Date,
};
